<template>
    <div class="sag-search-standard" :class="'sag-search-standard-'+FieldNo">
        
        <b-row class="mb-1" align-v="center" align-h="center">
            <b-col class="text-right" cols="3">
                <label :for="'tb-'+FieldNo">{{ label }}</label>
            </b-col>
            <b-col cols="3">
                <sag-form-select v-model="selected"
                    :options="options"
                    :FieldNo="FieldNo"
                    :id="'cb-'+FieldNo"
                    
                >
                </sag-form-select>
            </b-col>
            <b-col cols="6">
                <b-form-input v-model="tbValue" :id="'tb-'+FieldNo" trim></b-form-input>
            </b-col>
        </b-row>

    </div>
</template>
<script>
import { 
    BRow, 
    BCol,
    BFormInput,
    BFormGroup,
} from 'bootstrap-vue'
import SagFormSelect from '@/components/basic/SagFormSelect.vue'
import SagFormTextBox from '@/components/basic/SagFormTextBox.vue'
import { ref, watch } from '@vue/composition-api'
export default {
    components: {
        SagFormSelect,
        SagFormTextBox,
        BRow, 
        BCol,
        BFormInput,
        BFormGroup
    },  
    props: {
        label: {
            type: String,
            default: 'Default'
        },
        ConditionalType: {
            type: Number,
            default: 1
        },
        FieldNo: {
            type: String,
            required: true
        },
        FieldValue: {
            type: String,
            required: true
        }
    },
    setup(props, { emit }){
        const options = ref([
            {value: 0, text: "="},
            {value: 1, text: "Like"},
            {value: 2, text: ">"},
            {value: 3, text: ">="},
            {value: 4, text: "<"},
            {value: 5, text: "<="},
            {value: 6, text: "IN"},
            {value: 7, text: "NOT IN"},
            {value: 10, text: "<>"},
            {value: 13, text: "NOT LIKE"}
        ])        

        const selected = ref(props.ConditionalType)
        const tbValue = ref(props.FieldValue)

        watch(selected, (newValue, oldValue) => {
            emit("selected", {
                FieldValue: tbValue.value,
                ConditionalType: newValue
            })
        })
        watch(tbValue, (newValue, oldValue) => {
            emit("tbValue", {
                FieldValue: newValue,
                ConditionalType: selected.value
            })
        })
        

        return {
            options,
            selected,
            tbValue
        }
    }
}
</script>